<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page" v-show="show">
      <div class="circle_background_mob" ></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <div class="logo_form">
            </div>
          <div class="form_title">
            <h1>{{ getTranslations.visitor_sign_up_3_almost_done }}</h1>
          </div>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container">
              <div class="StandardRegSteps_step step_done">1</div>
              <div class="StandardRegSteps_step step_done">2</div>
              <div class="StandardRegSteps_step">3</div>
            </div>
          </div>
          <div class="signup-form">
            <form action="">
              <span v-if="facebookFunctionality"
                      class="fb_span">
                {{ getTranslations.visitor_sign_up_3_create_only }}
              </span>
              <div v-if="facebookFunctionality"
                   class="form-group form-group--icon fb_login"
                   :class="[ !errorInFb? '' : 'has-warning' ]">
                <facebook-login :errorsInFb="errorInFb"
                                :enteredUsername="testUser"
                                :type="fbActionType"
                                @errorsUpdated="methodForEvent($event)"
                                @waitForCoreResponse="methodForResponse($event)">
                </facebook-login>
                <span v-if="errorInFb"
                      class="form-group__feedback">{{ getFbMessage() }}</span>
              </div>
              <div v-if="facebookFunctionality"
                   class="form-group form-group--or">
                <div>
                  <span>{{ getTranslations.visitor_sign_up_and_login_or }}</span>
                </div>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsUsername ? '' : 'has-warning' ]">
                <input type="text"
                       class="form-group__textfield"
                       :class="[ !hasErrorsUsername ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_3_placeholder_create_username"
                       @keyup="check()"
                       v-model="user.username"
                       maxlength="12"/>
                <span v-show="getMessage(messageForUsername)"
                      class="form-group__feedback">{{ getMessage(messageForUsername) }}</span>
                <div v-show="user.proposedUsername"
                     class="form-group__suggestion">
                  <div class="form-group form-group--radio">
                    <input id="name2"
                           type="radio"
                           :value="user.proposedUsername"
                           v-model="user.username"
                           @change="change">
                    <label for="name2">{{ user.proposedUsername }}</label>
                  </div>
                </div>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsPassword ? '' : 'has-warning' ]">
                <input type="password"
                       class="form-group__textfield"
                       :class="[ !hasErrorsPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_3_placeholder_create_password"
                       @keyup="checkPassword"
                       v-model="user.password"/>
                <span v-show="getMessage(messageForPassword) && user.password"
                      class="form-group__feedback">{{ getMessage(messageForPassword) }}</span>
                <span v-show="getMessage(messageForFinalPassword)"
                      class="form-group__feedback">{{ getMessage(messageForFinalPassword) }}</span>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsConfirmPassword ? '' : 'has-warning' ]">
                <input type="password"
                       class="form-group__textfield"
                       :class="[ !hasErrorsConfirmPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_3_placeholder_confirm_password"
                       @keyup="checkPassword"
                       v-model="user.confirmPassword"/>
                <span v-show="getMessage(messageForConfirmPassword) && user.confirmPassword"
                      class="form-group__feedback">{{ getMessage(messageForConfirmPassword) }}</span>
                <span v-show="getMessage(finalMessage)"
                      class="form-group__feedback">{{ getMessage(finalMessage) }}</span>
              </div>
              <div class="form-group form-group--checkbox">
                <input id="remember_me"
                       type="checkbox"
                       value="remember_me_checked"
                       v-model="rememberMeParameter">
                <label for="remember_me">
                  {{ getTranslations.visitor_sign_up_3_remember_me }}
                </label>
              </div>
              <input type="submit"
                     :value="getTranslations.visitor_sign_up_3_submit_button_sign_up"
                     :class="['btn btn--medium btn--main', ( waitForResponse || hasErrorsUsername || hasErrorsPassword || hasErrorsConfirmPassword  ? 'deactivated' : '') ]"
                     @click.prevent="checkButton">
            </form>
          </div>
        </div>
      </div>
    </div>
    <loading v-if="showPleaseWait"
             @close="showPleaseWait = false">
    </loading>
  </div>
</template>

<script>

import loading from '@/components/home/modals/Loading';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import FacebookLogin from '.././FacebookLogin';

export default {
  components: { FacebookLogin, loading },
  name: 'sign-up-3',
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      show: true,
      testUser: 'User',
      waitForResponse: false,
      user: {
        username: '',
        password: '',
        confirmPassword: '',
        proposedUsername: '',
      },
      proposedUsername: '',
      username: '',
      fbActionType: 'register',
      errorInFb: false,
      messageForPassword: '',
      messageForUsername: '',
      messageForConfirmPassword: '',
      messageForFinalPassword: '',
      hasErrorsUsername: false,
      hasErrorsPassword: false,
      hasErrorsConfirmPassword: false,
      finalMessage: '',
      message: '',
      tokenExists: false,
      rememberMeParameter: true,
      fbMessageUsernameError: '',
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.showPage(false);
      vm.checkExternalSubscription(to);
    });
  },
  created() {
    const inputMsisdn = this.$route.query.userMsisdn || this.$route.query.msisdn || sessionStorage.getItem('msisdn');
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
    const operator = this.$route.query.operator;
    if (operator) {
      this.storeOperator(operator);
    }
    if (this.integrationHeader === this.availableIntegrations.DCB_POLAND.name) {
      if (inputMsisdn) {
        this.setShowPleaseWait(true);
        this.$axios.get(`api/getStatusForPoland?msisdn=${inputMsisdn}`).then((response) => {
          if (response.data.responseEnum === 'ALREADY_REGISTERED') {
            this.$router.push('/login');
          } else if (response.data.responseEnum === 'SERVER_ERROR') {
            this.$router.push('/');
          }
          this.setShowPleaseWait(false);
        }).catch((error) => {
          // eslint-disable-next-line
          console.log(`Invoking checkExternalSubscription failed with the following error: ${error}`);
        });
      } else {
        this.$router.push('/');
      }
    }
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
      'setFirstTimeEntry',
      'setShowPleaseWait',
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'callForAuthorization',
      'getUserLoginDetails',
    ]),
    showPage(value) {
      this.show = value;
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslations[key] || '';
    },
    getFbMessage() {
      if (!this.fbMessageUsernameError) return this.getTranslations.visitor_sign_up_3_this_fb;
      return this.getTranslations.visitor_sign_up_3_fb_username_first;
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    methodForResponse(event) {
      this.waitForResponse = event;
    },
    checkExternalSubscription(to) {
      if (to.query.msisdn && to.query.date && to.query.lang && to.query.digest) {
        const msisdn = encodeURIComponent(to.query.msisdn);
        const mergedParams = to.query[this.mergedParam] ? encodeURIComponent(to.query[this.mergedParam]) : '';
        this.$axios.get(`api/externalSubscribe?msisdn=${msisdn}&lang=${to.query.lang}&date=${encodeURIComponent(to.query.date)}&signature=${encodeURIComponent(to.query.digest)}&params=${mergedParams}`).then((response) => {
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (!this.isString(response.data.data) && this.hasSimplify()) {
              if (response.data.data.result === 'SUCCESS') {
                this.storeLoginInfo({
                  token: response.data.data.token,
                  rememberMeParameter: this.rememberMeParameter,
                  username: response.data.data.username,
                });
                this.getUserLoginDetails().then(() => {
                  this.setFirstTimeEntry(true);
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              }
            }
            if (response.data.data === 'SUCCESS') {
              this.showPage(true);
              this.setRegistrationInfo(msisdn);
            } else if (response.data.data === 'ALREADY_REGISTERED') {
              this.$router.push('/login');
            } else {
              this.$router.push('/');
            }
          } else {
            this.$router.push('/');
          }
        });
      } else this.showPage(true);
    },
    check(evt) {
      const max = 12;
      const min = 3;
      this.messageForFinalPassword = '';
      this.finalMessage = '';
      this.errorInFb = false;
      this.hasErrorsUsername = false;
      this.messageForUsername = '';
      if (this.user.username === '') {
        this.hasErrorsUsername = false;
      } else {
        // eslint-disable-next-line
        if (this.user.username.length < min) {
          this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_at_least_3_chars_long';
          this.user.proposedUsername = '';
          this.hasErrorsUsername = true;
        } else {
          this.messageForUsername = '';
          if (this.user.username.length > max) {
            this.user.username = this.checkMaxChar(this.user.username, max, evt);
            this.hasErrorsUsername = true;
          }
          this.hasErrorsUsername = false;
          // eslint-disable-next-line
          const validUsernameRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
          const validUsername = this.user.username.match(validUsernameRegex);
          if (validUsername === null) {
            this.hasErrorsUsername = true;
            this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_criteria';
            return;
          }
          this.$axios.get(`publicapi/checkUsername?username=${this.user.username}&msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}`).then((response) => {
            const res = response.data.data.msg;
            if (res === 'Username exists') {
              this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_taken_below';
              this.hasErrorsUsername = true;
            } else if (res === 'Invalid') {
              this.hasErrorsUsername = true;
              this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_blacklist_word';
            } else {
              this.messageForUsername = response.data.data.msg;
            }
            this.user.proposedUsername = response.data.data.prpusn;
          });
        }
      }
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          // Maximum exceeded
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    checkPassword(evt) {
      const min = 4;
      const max = this.maximumDigitsPinLength;
      this.messageForFinalPassword = '';
      this.messageForConfirmPassword = '';
      this.messageForPassword = '';
      this.finalMessage = '';
      this.errorInFb = false;
      // eslint-disable-next-line
      const validPasswordRegex = /^[0-9]{0,8}$/;
      // const validPasswordRegex = /^[a-z0-9@]+$/i; //mono arithmous grammata kai @ /tested in regex101.com
      // ^(?=.*[a-z])(?=.*\d)(?!.*\W)_?.+$ /?! negative lockhead _?(optional _ )
      // /^(?=.*[a-z])(?=.*\d)(?=.*_).+$/
      // https://stackoverflow.com/questions/1559751/regex-to-make-sure-that-the-string-contains-at-least-one-lower-case-char-upper
      const validPassword = this.user.password.match(validPasswordRegex);
      this.hasErrorsPassword = false;
      if (this.user.password.length < min || this.user.confirmPassword.length > max) {
        if (this.user.password.length < min) {
          this.messageForPassword = 'visitor_sign_up_3_info_wrong_password_warning_msg_at_least_6_chars';
          this.hasErrorsPassword = true;
        }
        if (this.user.confirmPassword.length > max) {
          this.user.confirmPassword = this.checkMaxChar(this.user.confirmPassword, max, evt);
          this.checkPassword();
        }
      } else if (this.user.password.length > max) {
        this.user.password = this.checkMaxChar(this.user.password, max, evt);
        this.hasErrorsPassword = true;
        this.checkPassword();
      } else if (validPassword !== null) {
        if (this.user.password.length > max) {
          this.user.password = this.checkMaxChar(this.user.password, max, evt);
          this.hasErrorsPassword = true;
          this.checkPassword();
        }
        this.messageForPassword = '';
        if (this.user.confirmPassword.length < min) {
          this.messageForConfirmPassword = 'visitor_sign_up_3_passwords_do_not_match';
          this.hasErrorsPassword = true;
          this.hasErrorsConfirmPassword = true;
        }
        if (this.user.confirmPassword !== '' && (this.user.confirmPassword === this.user.password)) {
          this.messageForConfirmPassword = '';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = false;
        } else {
          this.messageForConfirmPassword = 'visitor_sign_up_3_passwords_do_not_match';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = true;
        }
      } else if (validPassword === null) {
        this.hasErrorsPassword = true;
        // eslint-disable-next-line
        this.messageForPassword = 'visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_';
      }
      if (this.user.password === '') {
        this.hasErrorsPassword = false;
        this.hasErrorsConfirmPassword = false;
      } else if (this.user.confirmPassword === '') {
        this.hasErrorsConfirmPassword = false;
      }
//      if (this.hasErrorsPassword && this.user.password.length >= min) {
//        const passwordWithoutLetter = this.user.password.match(/^(?!.*[A-Za-z]).+$/);
//        const passwordWithoutNumber = this.user.password.match(/^(?!.*\d).+$/);
//        const passwordWithSymbolsExceptUnderscore = this.user.password.match(/^(?!.*\W)_?.+$/);
//        if (passwordWithoutLetter !== null) {
//          this.messageForPassword = this.getTranslations.visitor_sign_up_3_info_msg_password_does_not_contain_at_least_one_letter;
//        } else if (passwordWithoutNumber !== null) {
//          this.messageForPassword = this.getTranslations.visitor_sign_up_3_info_msg_password_does_not_contain_at_least_one_1_digit;
//        } else if (passwordWithSymbolsExceptUnderscore === null) {
//          this.messageForPassword = this.getTranslations.visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_;
//        }
//      }
    },
    change() {
      this.user.proposedUsername = '';
      this.finalMessage = '';
      this.hasErrorsUsername = false;
      this.messageForUsername = '';
      this.errorInFb = false;
      this.messageForFinalPassword = '';
    },
    checkButton() {
      this.errorInFb = false;
      if ((this.user.username !== '') && (this.hasErrorsPassword === false) && (this.hasErrorsUsername === false) && (this.hasErrorsConfirmPassword === false) && !(this.user.password === '') && !(this.user.confirmPassword === '')) {
        this.messageForUsername = '';
        this.waitForResponse = true;
        this.$axios.get(`api/subscribeUser?msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&username=${this.user.username}&password=${this.user.password}&lang=${this.getLocale}&fbReferral=${this.fbReferral}&freePlayPoints=${this.freeTrialUserPrice || ''}&operator=${this.multiOperatorInfo.operatorPicked || ''}`).then((responseUser) => {
          const res = responseUser.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.message = '';
            const userData = {
              username: this.user.username,
              password: this.user.password,
              rememberMe: this.rememberMeParameter,
            };
            this.callForAuthorization(userData).then(() => {
              if (this.getUserAuthorized) {
                this.getUserLoginDetails().then(() => {
                  this.setFirstTimeEntry(true);
                  this.updateUserLanguage();
                  this.$router.push('home');
                  this.waitForResponse = false;
                });
              } else {
                this.message = 'SERVER_ERROR';
                this.waitForResponse = false;
              }
            });
          } else {
            // eslint-disable-next-line
            if (res === 'MSISDN_INVALID') {
              this.finalMessage = 'visitor_sign_up_invalid_msisdn_msg';
            } else if (res === 'ALREADY_REGISTERED') {
              this.finalMessage = 'visitor_sign_up_msisdn_already_registered';
            } else if (res === 'MSISDN_NOT_EXIST') {
              this.finalMessage = 'visitor_sign_up_msisdn_not_exists';
            } else if (res === 'MSISDN_BLACKLISTED') {
              this.finalMessage = 'visitor_sign_up_msisdn_blacklisted';
            } else if (res === 'BLOCKED_USER') {
              this.finalMessage = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'SERVER_ERROR') {
              this.finalMessage = 'home_profile_profile_edit_server_unvailable';
            }
            this.waitForResponse = false;
          }
        });
      } else {
        // eslint-disable-next-line
        if (this.user.username === '') {
          this.hasErrorsUsername = true;
          this.messageForUsername = 'visitor_sign_up_3_fb_username_first';
        } else if (this.user.password === '') {
          this.hasErrorsPassword = true;
          this.messageForPassword = '';
          this.messageForFinalPassword = 'visitor_sign_up_3_info_wrong_password_warning_msg_at_least_6_chars';
        } else if (this.user.confirmPassword === '') {
          this.hasErrorsConfirmPassword = true;
          this.messageForConfirmPassword = '';
          this.finalMessage = 'visitor_sign_up_3_passwords_do_not_match';
        }
      }
    },
  },
  computed: {
    ...mapState('common', [
      'freeTrialUserPrice',
      'facebookFunctionality',
      'integrationHeader',
      'availableIntegrations',
      'fbReferral',
      'multiOperatorInfo',
      'mergedParam',
      'maximumDigitsPinLength',
    ]),
    ...mapState('game', [
      'registrationPoints',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
      'showPleaseWait',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp3.vue